export class BatchOperation {
  public static readonly DELIVERED = 1;
  public static readonly SENT_2_MAIL = 2;
  public static readonly VISUALIZED = 3;
}
